"use client";

import React, { useState } from "react";
import { useForm } from "react-hook-form";

type FormValues = {
	name: string;
	business: string;
	email: string;
	phone: string;
	website: string;
	role: string;
	goals: string;
};

export default function EbookDownload() {
  const [showForm, setShowForm] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    try {
      await fetch(
        "https://n8n.salesmrkt.com/webhook/19e9367b-10d5-40f8-838c-149a7770db7a",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );
      reset();
      alert("Form submitted successfully");
    } catch (error) {
      alert(" Something went wrong.");
      console.error(error);
    }
  };

  return (
		<div className="justify-center sm:justify-left pl-0 sm:pl-8 lg:pl-12 flex items-center">
			<div className="flex flex-col items-start gap-4 lg:gap-6">
				<div className="gap-2 lg:gap-4">
					<p className="text-white text-[2rem] lg:text-center font-semibold lg:text-[3.8rem] xl:text-[4.5rem] leading-none md:leading-none lg:leading-[4.2rem] xl:leading-[5.2rem] h-fit pt-4">
						Get a <span className="text-black font-bold">FREE</span> Ebook
					</p>
					<p className="text-black font-bold text-[1.5rem] lg:text-[2.5rem] xl:text-[3rem]">
						Video Production LeadGen
					</p>
				</div>

				{!showForm ? (
					<button
						onClick={() => setShowForm(true)}
						className="bg-black text-white flex mb-5 justify-center items-center text-sm md:text-base py-1 md:py-2 lg:text-xl xl:text-2xl lg:h-14 xl:h-16 rounded-full px-4 md:px-6 lg:px-10 xl:px-12 hover:border hover:border-black hover:bg-white hover:text-black transition-all duration-200 ease-in-out whitespace-nowrap"
					>
						Get Ebook
					</button>
				) : (
					<form
						onSubmit={handleSubmit(onSubmit)}
						className="bg-white shadow-md rounded-lg p-3 md:p-6 mb-6 sm:mb-8 md:mb-5 lg:mb-10 flex flex-col gap-3 sm:gap-4 w-full max-w-sm sm:max-w-md md:max-w-lg"
					>
						<input
							type="text"
							placeholder="Name"
							{...register("name", { required: "Name is required" })}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.name && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.name.message}
							</p>
						)}

						<input
							type="text"
							placeholder="Business"
							{...register("business", { required: "Business is required" })}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.business && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.business.message}
							</p>
						)}

						<input
							type="text"
							placeholder="Website"
							{...register("website", { required: "Website is required" })}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.website && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.website.message}
							</p>
						)}

						<input
							type="text"
							placeholder="Role / Job Title"
							{...register("role", {
								required: "Role / Job Title is required",
							})}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.role && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.role.message}
							</p>
						)}

						<input
							type="email"
							placeholder="Work Email"
							{...register("email", {
								required: "Email is required",
								pattern: { value: /^\S+@\S+$/i, message: "Invalid email" },
							})}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.email && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.email.message}
							</p>
						)}

						<input
							type="text"
							placeholder="Phone"
							{...register("phone", { required: "Phone is required" })}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>
						{errors.phone && (
							<p className="text-red-500 text-xs sm:text-sm">
								{errors.phone.message}
							</p>
						)}

						{/* Goals (Textarea) */}
						<textarea
							placeholder="Describe your key sales and marketing goals (Optional)"
							{...register("goals")}
							rows={4}
							className="border border-gray-300 p-2 md:p-3 rounded-md text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
						/>

						<button
							type="submit"
							disabled={isSubmitting}
							className="bg-black text-white py-2 sm:py-3 rounded-md hover:bg-gray-800 transition text-sm sm:text-base font-medium disabled:opacity-50 disabled:cursor-not-allowed"
						>
							{isSubmitting ? "Submitting..." : "Submit & Download"}
						</button>
					</form>
				)}
			</div>
		</div>
	);
}
